import Link from 'next/link';

const SocialLinks = () => {
  return (
    <div className='mt-[30px] flex items-center justify-center gap-x-9 lg_justify-start'>
      {socialLinkConfigs.map(({ svg, href, text }, i) => {
        return (
          <Link
            href={href}
            aria-label={text}
            key={i}
          >
            <span className='hidden'>{text}</span>
            {svg}
          </Link>
        );
      })}
    </div>
  );
};

const socialLinkConfigs = [
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='10'
        height='21'
        fill='none'
        viewBox='0 0 10 21'
      >
        <path
          fill='#80583F'
          d='M9.714 10.93H6.206v9.444H2.563V10.93H0V7.557h2.563V4.589C2.563 2.295 4.047.137 7.42.137c1.35 0 2.429.135 2.429.135L9.714 3.51H7.555c-1.214 0-1.349.54-1.349 1.484v2.428h3.643z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M9.714 10.93H6.206v9.444H2.563V10.93H0V7.557h2.563V4.589C2.563 2.295 4.047.137 7.42.137c1.35 0 2.429.135 2.429.135L9.714 3.51H7.555c-1.214 0-1.349.54-1.349 1.484v2.428h3.643z'
        />
      </svg>
    ),
    href: 'https://www.facebook.com/aw.bridal/',
    text: "AW.Bridal's Facebook Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='21'
        fill='none'
        viewBox='0 0 18 21'
      >
        <path
          fill='#80583F'
          d='M4.22 19.326c0-.81 0-1.89.27-2.834s1.62-6.61 1.62-6.61-.405-.81-.405-1.889c0-1.754 1.079-3.103 2.293-3.103 1.08 0 1.619.81 1.619 1.889 0 1.08-.675 2.833-1.08 4.317-.27 1.214.675 2.294 1.89 2.294 2.293 0 3.912-2.969 3.912-6.476 0-2.699-1.754-4.722-4.992-4.722-3.642 0-5.936 2.698-5.936 5.801 0 1.08.27 1.754.81 2.428.27.27.27.405.134.675 0 .27-.135.81-.27.944-.134.27-.27.405-.674.27C1.657 11.636.848 9.747.848 7.723.848 4.35 3.816.168 9.482.168c4.587 0 7.69 3.373 7.69 7.015 0 4.723-2.698 8.365-6.61 8.365-1.35 0-2.564-.674-2.969-1.484 0 0-.674 2.833-.81 3.373-.269.944-.809 1.889-1.213 2.563.135-.135-1.08 1.215-1.35-.674'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M4.22 19.326c0-.81 0-1.89.27-2.834s1.62-6.61 1.62-6.61-.405-.81-.405-1.889c0-1.754 1.079-3.103 2.293-3.103 1.08 0 1.619.81 1.619 1.889 0 1.08-.675 2.833-1.08 4.317-.27 1.214.675 2.294 1.89 2.294 2.293 0 3.912-2.969 3.912-6.476 0-2.699-1.754-4.722-4.992-4.722-3.642 0-5.936 2.698-5.936 5.801 0 1.08.27 1.754.81 2.428.27.27.27.405.134.675 0 .27-.135.81-.27.944-.134.27-.27.405-.674.27C1.657 11.636.848 9.747.848 7.723.848 4.35 3.816.168 9.482.168c4.587 0 7.69 3.373 7.69 7.015 0 4.723-2.698 8.365-6.61 8.365-1.35 0-2.564-.674-2.969-1.484 0 0-.674 2.833-.81 3.373-.269.944-.809 1.889-1.213 2.563.135-.135-1.08 1.215-1.35-.674'
        />
      </svg>
    ),
    href: 'https://www.pinterest.com/aw_bridal/',
    text: "AW.Bridal's Pinterest Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='18'
        fill='none'
        viewBox='0 0 24 18'
      >
        <path
          fill='#80583F'
          fillRule='evenodd'
          d='M19.06.754H4.412C2.1.754.172 2.628.172 5.305v7.764c0 2.543 1.927 4.685 4.24 4.685h14.52c2.313 0 4.24-2.142 4.24-4.685V5.305c0-2.543-1.799-4.551-4.112-4.551M9.295 13.069V5.573L15.59 9.32z'
          clipRule='evenodd'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          fillRule='evenodd'
          d='M19.06.754H4.412C2.1.754.172 2.628.172 5.305v7.764c0 2.543 1.927 4.685 4.24 4.685h14.52c2.313 0 4.24-2.142 4.24-4.685V5.305c0-2.543-1.799-4.551-4.112-4.551M9.295 13.069V5.573L15.59 9.32z'
          clipRule='evenodd'
        />
      </svg>
    ),
    href: 'https://www.youtube.com/@aw.bridal/videos',
    text: "AW.Bridal's Youtube Page",
  },
  {
    svg: (
      <svg
        width='18'
        height='21'
        viewBox='0 0 18 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.27397 0.283661C10.3625 0.26709 11.443 0.275375 12.5232 0.26709C12.5896 1.53963 13.0466 2.83727 13.9774 3.73575C14.9081 4.65909 16.2211 5.0831 17.501 5.22469V8.57662C16.3043 8.53495 15.0995 8.28541 14.0107 7.76977C13.5369 7.55362 13.0965 7.27898 12.6644 6.9963C12.6561 9.42515 12.6727 11.854 12.6478 14.2743C12.5814 15.4389 12.1991 16.5949 11.526 17.5514C10.4375 19.1486 8.5509 20.1881 6.61491 20.2215C5.42659 20.288 4.23826 19.9637 3.22425 19.3647C1.5456 18.3748 0.365553 16.5616 0.191236 14.6152C0.174681 14.1992 0.16616 13.7835 0.182959 13.3758C0.332686 11.7955 1.1137 10.2817 2.32686 9.25018C3.7063 8.05245 5.63426 7.47856 7.43756 7.81948C7.45411 9.0506 7.40445 10.2815 7.40445 11.5126C6.5818 11.2465 5.6177 11.3213 4.89487 11.8204C4.37143 12.1615 3.9724 12.6855 3.76473 13.2762C3.59017 13.7004 3.64008 14.1661 3.64836 14.6152C3.84775 15.9794 5.16073 17.1272 6.55672 17.0024C7.48747 16.9941 8.37658 16.4534 8.85863 15.6633C9.01639 15.3887 9.19095 15.106 9.19948 14.7817C9.28249 13.2927 9.24938 11.8121 9.25766 10.3234C9.2657 6.9712 9.2489 3.62755 9.27397 0.283661Z'
          fill='#80583F'
        />
      </svg>
    ),
    href: 'https://www.tiktok.com/@awbridal_official?lang=zh-Hant-TW',
    text: "AW.Bridal's Tiktok Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='21'
        height='21'
        fill='none'
        viewBox='0 0 21 21'
      >
        <path
          fill='#80583F'
          d='M10.3 4.992c-2.763 0-5 2.294-5 5.127s2.237 5.127 5 5.127 4.998-2.294 4.998-5.127-2.236-5.127-4.999-5.127m0 8.635c-1.842 0-3.29-1.484-3.29-3.373S8.459 6.88 10.3 6.88c1.84 0 3.288 1.484 3.288 3.373s-1.447 3.373-3.289 3.373'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M10.3 4.992c-2.763 0-5 2.294-5 5.127s2.237 5.127 5 5.127 4.998-2.294 4.998-5.127-2.236-5.127-4.999-5.127m0 8.635c-1.842 0-3.29-1.484-3.29-3.373S8.459 6.88 10.3 6.88c1.84 0 3.288 1.484 3.288 3.373s-1.447 3.373-3.289 3.373'
        />
        <path
          fill='#80583F'
          d='M14.378 0H5.96C2.803 0 .172 2.698.172 5.936v8.635c0 3.238 2.63 5.936 5.788 5.936h8.418c3.157 0 5.788-2.698 5.788-5.936V5.936c0-3.238-2.63-5.936-5.788-5.936m3.947 14.3c0 2.294-1.842 4.183-4.078 4.183H6.354c-2.236 0-4.077-1.889-4.077-4.182V6.34c0-2.294 1.841-4.182 4.077-4.182h7.893c2.236 0 4.078 1.888 4.078 4.182z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M14.378 0H5.96C2.803 0 .172 2.698.172 5.936v8.635c0 3.238 2.63 5.936 5.788 5.936h8.418c3.157 0 5.788-2.698 5.788-5.936V5.936c0-3.238-2.63-5.936-5.788-5.936m3.947 14.3c0 2.294-1.842 4.183-4.078 4.183H6.354c-2.236 0-4.077-1.889-4.077-4.182V6.34c0-2.294 1.841-4.182 4.077-4.182h7.893c2.236 0 4.078 1.888 4.078 4.182z'
        />
        <path
          fill='#80583F'
          d='M15.43 3.645c-.658 0-1.184.54-1.184 1.214s.526 1.214 1.184 1.214 1.184-.54 1.184-1.214c0-.675-.526-1.214-1.184-1.214'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M15.43 3.645c-.658 0-1.184.54-1.184 1.214s.526 1.214 1.184 1.214 1.184-.54 1.184-1.214c0-.675-.526-1.214-1.184-1.214'
        />
      </svg>
    ),
    href: 'https://www.instagram.com/aw.bridal/',
    text: "AW.Bridal's Instagram Page",
  },
];

export default SocialLinks;
